<template>
  <v-dialog 
    v-model="activeMode"  
    max-width="500"
    @click:outside="closeForm()"
    :fullscreen="$vuetify.breakpoint.smAndDown"
  >
    <v-card>
      <v-toolbar
        color="primary"
        dark
        flat
      >
        <v-toolbar-title>Данные по городам</v-toolbar-title>
        <v-spacer></v-spacer>

        <v-btn icon @click="closeForm()">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      
      <v-card-text class="mt-2">
        <v-text-field
          v-for="key of Object.keys(obj)"
          :label="key"
          v-model="obj[key]"
          :key="key"
          class="mt-2"
          filled
        ></v-text-field>
      </v-card-text>

      <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closeForm()">Закрыть</v-btn>
          <v-btn 
            color="blue darken-1" 
            text 
            @click="save"
          >Сохранить</v-btn>
        </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import _ from 'lodash';
import { mapState, mapGetters } from 'vuex';

export default {
  name: 'site-testimonials-cities-data',
  props: {
    value: Object,
    activeMode: Boolean,
  },
  data() {
    //alert(this.value);
    return {
      obj: Boolean(this.value) ? _.cloneDeep(this.value) : this.getDefaultObj()
    }
  },
  methods: {
    getDefaultObj() {
      //alert(this.$store.state.sites.cities);
      let obj = {};
      for (let city of this.$store.state.sites.cities) obj[city] = '';
      //alert(obj);
      return obj;
    },
    save() {
      this.$emit('input', this.obj);
      this.$nextTick(() => this.closeForm());
    },
    closeForm() {
      this.obj = this.value ? _.cloneDeep(this.value) : this.getDefaultObj();
      this.$emit('closeForm');
    }
  },
  computed: {
    ...mapState('sites', ['cities']),
  }
}
</script>